import { AdversariesInfoLayer } from './AdversariesInfoLayer';
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { Background } from "../background/Background";
import { BootScene } from "../BootScene";
import { AudioManager } from "../../managers/AudioManager";
import { GameTitleContainer } from "./GameTitleContainer";
import { Table } from "../room/Table";
import { Button } from "../../utils/Button";
import { GameManager } from "../../managers/GameManager";
import { SplashBanan as SplashBanana } from "./SplashBanana";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;

    private backgroundBlack: Phaser.GameObjects.Graphics;
    private adversariesInfoLayer: AdversariesInfoLayer;

    constructor() {

        super("SplashScene");

        SplashScene.currentInstance = this;
    }

    public create(): void {

        GameVars.currentScene = this;

        const background = new Background(this);
        this.add.existing(background);

        // LOS CREDITOS
        this.addCredits();

        const table = new Table(this);
        table.y = 380;
        table.setScale(.9 * GameVars.scaleX, .9);
        this.add.existing(table);

        const gameTitle = new GameTitleContainer(this);
        this.add.existing(gameTitle);

        const splashBanana = new SplashBanana(this);
        this.add.existing(splashBanana);

        // EL BOTON DE PLAY
        const playButtonContainer = this.add.container(GameConstants.GAME_WIDTH / 2, 560);
        playButtonContainer.scaleX = GameVars.scaleX;

        const playButton = new Button(this, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        playButton.onUp(this.onClickPlay, this);
        playButtonContainer.add(playButton);

        const playButtonLabel = new Phaser.GameObjects.Text(this, 0, -15, "PLAY NOW", {fontFamily: "Oswald-Medium", fontSize: "24px", color: "#622F20", align: "center"});
        playButtonLabel.setOrigin(.5);
        playButtonContainer.add(playButtonLabel); 

        const roomPriceLabel = new Phaser.GameObjects.Text(this, - 10, 14, GameVars.formatNumber(GameConstants.ROOM_PRICE), {fontFamily: "Oswald-Medium", fontSize: "22px", color: "#622F20", align: "center"});
        roomPriceLabel.setOrigin(.5);
        playButtonContainer.add(roomPriceLabel); 

        const chipIcon = new Phaser.GameObjects.Image(this, 36, 14, "texture_atlas_1", "chip_pot_icon.png");
        chipIcon.setScale(.9);
        playButtonContainer.add(chipIcon);

        // EL BOTON DE HI AND LO

        if (!GameVars.gameData.firstTime) {
            const hiLoButtonContainer = this.add.container(GameConstants.GAME_WIDTH / 2 + 105 * GameVars.scaleX, 565);
            hiLoButtonContainer.scaleX = GameVars.scaleX;

            const hiLoButton = new Button(this, 0, 0,  "texture_atlas_1", "btn_hi-lo.png", "btn_hi-lo.png", true);
            hiLoButton.onUp(this.onClickHighLow, this);
            hiLoButtonContainer.add(hiLoButton);

            playButtonContainer.x = GameConstants.GAME_WIDTH / 2 - 85 * GameVars.scaleX;

            if (GameVars.gameData.chips < GameConstants.ROOM_PRICE) {

                playButtonContainer.alpha = .5;
                playButton.input.enabled = false;
    
                this.tweens.add({
                    targets: hiLoButtonContainer,
                    scaleX: 1.05 * GameVars.scaleX,
                    scaleY: .95,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 320,
                    repeat: -1,
                    yoyo: true
                });
            }

            const infoButtonContainer = this.add.container(35 * GameVars.scaleX, GameConstants.GAME_HEIGHT - 35);
            infoButtonContainer.scaleX = GameVars.scaleX;

            const infoButton = new Button(this, 0, 0, "texture_atlas_1", "btn_info_chars.png", "btn_info_chars.png", true);
            infoButton.onUp(this.showAdversariesInfoLayer, this);
            infoButtonContainer.add(infoButton);
        }

        const audioButton = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH - 35 * GameVars.scaleX, 35, "texture_atlas_1");

        if (GameVars.gameData.muted) {
            audioButton.setFrame("btn_sound_off.png");
        } else {
            audioButton.setFrame("btn_sound_on.png");
        }

        audioButton.setInteractive();

        audioButton.on("pointerdown", () => {
            audioButton.setScale(GameVars.scaleX, 1);
        }, this);

        audioButton.on("pointerup", () => {
            this.onDownAudioButton(audioButton);
        }, this);

        audioButton.on("pointerover", () => {
            audioButton.setScale(GameVars.scaleX * 1.05, 1.05);
        }, this);

        audioButton.on("pointerout", () => {
            audioButton.setScale(GameVars.scaleX, 1);
        }, this);

        audioButton.scaleX = GameVars.scaleX;
        this.add.existing(audioButton);

        // el texto del copyright
        const copyrightLabel = this.add.text(GameConstants.GAME_WIDTH - 10 * GameVars.scaleX, GameConstants.GAME_HEIGHT - 8, "made by RavalMatic, licensed to " + GameConstants.SPONSOR, {fontFamily: "Oswald-Medium", fontSize: "20px", color: "#FFFFFF"});
        copyrightLabel.setOrigin(1);
        copyrightLabel.alpha = .5;
        copyrightLabel.scaleX = GameVars.scaleX;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            copyrightLabel.visible = false;
        }

        if (!this.sys.game.device.os.desktop && GameConstants.SPONSOR !== GameConstants.SPONSOR_FUNO) {
            this.input.on("pointerup", () => {

                if (!this.game.scale.isFullscreen) {
                    this.game.scale.startFullscreen();
                    BootScene.onOrientationChange();
                }
            }, this);
        }

        const backgroundCover = new Background(this);
        this.add.existing(backgroundCover);

        this.tweens.add({
            targets: backgroundCover,
            alpha: 0,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 500,
            delay: 300,
            onComplete: function(): void {
                backgroundCover.destroy();
            },
            onCompleteScope: this
        });

        this.backgroundBlack = new Phaser.GameObjects.Graphics(this);
        this.backgroundBlack.fillStyle(0x000000, .9);
        this.backgroundBlack.alpha = 0;
        this.backgroundBlack.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.backgroundBlack.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        this.backgroundBlack.on("pointerdown", () => { 
            //  
        });
        this.add.existing(this.backgroundBlack);

        this.adversariesInfoLayer = new AdversariesInfoLayer(this);
        this.add.existing(this.adversariesInfoLayer);

        if (GameConstants.SPONSOR !== GameConstants.SPONSOR_FUNO) {
            AudioManager.playMusic("soundtrack_splash", .2);
        }
    }

    private showAdversariesInfoLayer(): void {

        AudioManager.playSound("btn_click");

        this.adversariesInfoLayer.visible = true;
    }

    private addCredits(): void {

        const creditsContainer = this.add.container(100 * GameVars.scaleX, 35);
        creditsContainer.setScale(GameVars.scaleX * .8, .8);

        const w = 220;
        const h = 60;

        const creditsCartridge = new Phaser.GameObjects.Graphics(this);
        creditsCartridge.fillStyle(0x000000, .5);
        creditsCartridge.fillRoundedRect(-w / 2, -h / 2, w, h, h / 2);
        creditsContainer.add(creditsCartridge);

        const creditsLabel = new Phaser.GameObjects.Text(this, w / 2 - 60, -2, GameVars.formatNumber(GameVars.gameData.chips), {fontFamily: "Oswald-Medium", fontSize: "46px", color: "#ffffff"});
        creditsLabel.setOrigin(1, .5);
        creditsContainer.add(creditsLabel);

        const chipIconCreditsLabel = new Phaser.GameObjects.Image(this, w / 2 - 30, 0, "texture_atlas_1", "chip_pot_icon.png");
        chipIconCreditsLabel.setScale(1.2);
        creditsContainer.add(chipIconCreditsLabel);


        if (!GameVars.gameData.firstTime) {
            let moreButton = new Button(this, 225 * GameVars.scaleX, 35, "texture_atlas_1", "btn_add.png", "btn_add.png", true, true);
            moreButton.scaleX = GameVars.scaleX;
            moreButton.onUp(this.onClickHighLow, this);
            this.add.existing(moreButton); 
        }     
    }

    private onClickPlay(): void {

        this.tweens.add({
            targets: this.backgroundBlack,
            alpha: 1,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 800,
            onComplete: function(): void {
                if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
                    if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                        gdsdk.showAd();
                        GameVars.typeAd = "Enter Room Scene";
                    } else {
                        GameManager.enterRoomScene();
                    }
                } else {
                    GameManager.enterRoomScene();
                }
                
            },
            onCompleteScope: this
        });

        AudioManager.playSound("btn_click");
        
    }

    private onClickHighLow(): void {

        this.tweens.add({
            targets: this.backgroundBlack,
            alpha: 1,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 800,
            onComplete: function(): void {
                if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
                    if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                        gdsdk.showAd();
                        GameVars.typeAd = "Enter HiLo";
                    } else {
                        GameManager.enterHiLoScene();
                    }
                } else {
                    GameManager.enterHiLoScene();
                }
                
            },
            onCompleteScope: this
        });

        AudioManager.playSound("btn_click");
    }

    private onDownAudioButton(b: Phaser.GameObjects.Image): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            b.setFrame("btn_sound_off.png");
        } else {
            b.setFrame("btn_sound_on.png");
        }

        AudioManager.playSound("btn_click");
    }
}
